import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getCountryFromSubdomain, getCountryTheme } from '../config/countryThemes';
import { COUNTRIES } from '../config/countries';

// Detect country from subdomain once at module level
const subdomainCountry = getCountryFromSubdomain(window.location.hostname);

/**
 * Single source of truth for the current country.
 * On subdomains (e.g. fr.rentydoc.com) -> returns country from subdomain.
 * On main domain with legacy URL (/:country/:lang/...) -> returns country from URL params.
 */
export function useCountry() {
  const params = useParams();

  // Subdomain takes priority, then fall back to URL param for legacy routes
  const countryCode = subdomainCountry || params.country || null;
  const country = countryCode ? COUNTRIES[countryCode] : null;
  const theme = useMemo(() => getCountryTheme(countryCode), [countryCode]);

  return {
    countryCode,
    country,
    theme,
    isSubdomain: !!subdomainCountry,
  };
}

// Re-export for use outside of components
export { subdomainCountry };
